<sb-card>
  <div card-header>
    <h3>{{ 'lang.statisticOverview.channelBroadcastingQuota' | translate }}</h3>
  </div>
  <div card-header-more>
    <sb-comp-dropdown-select
      *ngPermissions="permissionService.Permission.cull_list"
      [showSubmit]="false" [singleSelectMode]="true"
      [inputData]="culls" [dropDownDatatype]="'PLAYER_CULLS'"
      (selectedDataEmitter)="update($event, 'PLAYER_CULLS')" [showColumnIcon]="false"
      [msOptions]="msCullOptions" (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
      [selectedInputData]="cull ? [cull] : []">
    </sb-comp-dropdown-select>
  </div>
  <div card-body>
    <sb-chart #chart chartType="barChart" [chartData]="chartData"></sb-chart>
  </div>
</sb-card>
